import { AddressService, Address } from 'ui-utils';

export function useAddress(value: Address) {
  return AddressService.toString(value);
}
